import { TextField, InputAdornment } from '@mui/material';
import { useRef, useState } from 'react';
 
import searchIcon from '../../../assets/images/faqImage/search.svg';
import cancel from '../../../assets/images/knownIssue/cancelIcon.svg';
 
const KnownIssuesSearch = ({ value, onChange, staticContent }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
 
  const handleFocus = () => {
    setIsFocused(true);
  };
 
  const handleBlur = () => {
    if (!value) {
      setIsFocused(false);
    }
  };
 
  const handleClearSearch = () => {
    onChange({ target: { value: '' } });
    setIsFocused(false);
    if (inputRef.current) inputRef.current.blur();
  };
 
  return (
    <section aria-label="Find known issues">
      <TextField
        id="known-issues-search"
        label={staticContent.searchLabel}
        variant="standard"
        value={value}
        inputRef={inputRef}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        sx={{
          mb: 2,
          minWidth: '272px',
          width: { xs: '100%', sm: '272px' },
        }}
        InputLabelProps={{
          htmlFor: 'known-issue-search',
          shrink: isFocused || Boolean(value), // animate on focus or value
          style: {
            marginLeft: '30px',
            fontWeight: isFocused || value ? 400 : 600,
            color: isFocused || value ? '#717173' : '#000000',
            transition: 'all 0.3s ease-in-out',
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img
                src={searchIcon}
                alt="search"
                style={{
                  width: 20,
                  height: 20,
                  marginBottom: '5px',
                }}
              />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <img
                src={cancel}
                alt="clear search"
                tabIndex={0}
                role="button"
                aria-label="Clear search input"
                style={{
                  width: 10,
                  height: 10,
                  marginBottom: '5px',
                  marginRight: '8px',
                  cursor: 'pointer',
                }}
                onClick={handleClearSearch}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleClearSearch();
                  }
                }}
              />
            </InputAdornment>
          ),
        }}
      />
    </section>
  );
};
 
export default KnownIssuesSearch;
 